import {
  EdgelessToolbarToolMixin,
  QuickToolMixin,
} from '@blocksuite/affine-widget-edgeless-toolbar';
import { PresentationIcon } from '@blocksuite/icons/lit';
import { css, html, LitElement } from 'lit';
import { state } from 'lit/decorators.js';

import { PresentTool } from '../present-tool';

/**
 * Awareness state type for follower detection
 */
interface FollowingAwarenessState {
  following?: {
    isFollowing: boolean;
  };
}

export class EdgelessPresentButton extends QuickToolMixin(
  EdgelessToolbarToolMixin(LitElement)
) {
  static override styles = css`
    :host {
      display: flex;
    }
    .edgeless-note-button {
      display: flex;
      position: relative;
    }
    .disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `;

  override type = PresentTool;

  @state()
  private accessor _isFollowing = false;

  override connectedCallback() {
    super.connectedCallback();
    this._setupFollowingListener();
  }

  private _setupFollowingListener(): void {
    if (!this.edgeless) return;
    const awareness = this.edgeless.std.store.awarenessStore.awareness;

    const handler = () => {
      const localState =
        awareness.getLocalState() as FollowingAwarenessState | null;
      this._isFollowing = !!localState?.following?.isFollowing;
    };

    awareness.on('change', handler);
    this._disposables.add(() => awareness.off('change', handler));

    // Initial check
    handler();
  }

  private _handleClick() {
    // Prevent activating presentation mode when following
    if (this._isFollowing) {
      console.log('[PresentButton] Blocked: User is following a presenter');
      return;
    }
    this.setEdgelessTool(PresentTool);
  }

  override render() {
    const tooltip = this._isFollowing
      ? 'Cannot present while following'
      : 'Present';

    return html`<edgeless-tool-icon-button
    class="edgeless-frame-navigator-button ${this._isFollowing ? 'disabled' : ''}"
    .tooltip=${tooltip}
    .tooltipOffset=${17}
    .iconContainerPadding=${6}
    .iconSize=${'24px'}
    @click=${() => this._handleClick()}
  >
    ${PresentationIcon()}
    </edgeless-tool-icon-button>
  </div>`;
  }
}
